import { Helmet } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import '../../assets/styles/UIUXDesign.css'
import wireframeImg from "../../assets/images/Wireframing.png";
import prototypeImg from "../../assets/images/Prototyping.png";
import usabilityImg from "../../assets/images/Usability Testing.png";
import designSystemImg from "../../assets/images/Design System.png";
import interactionImg from "../../assets/images/Interaction design.png";
import UiImg from "../../assets/images/ui-hero.jpg";

const UIUX = () => {
  const navigate = useNavigate();

  const uiuxServices = [
    {
      title: "Wireframing",
      description: "Creating blueprint layouts that establish structure and flow of user interfaces before the design stage.",
      image: wireframeImg,
      path: "/services/uiux/wireframing"
    },
    {
      title: "Prototyping",
      description: "Building interactive and clickable prototypes that simulate the end-user experience.",
      image: prototypeImg,
      path: "/services/uiux/prototyping"
    },
    {
      title: "Usability Testing",
      description: "Conducting user tests to gather feedback and improve design functionality and satisfaction.",
      image: usabilityImg,
      path: "/services/uiux/usability"
    },
    {
      title: "Design Systems",
      description: "Developing scalable UI guidelines, components, and assets for cohesive product design.",
      image: designSystemImg,
      path: "/services/uiux/designsystem"
    },
    {
      title: "Interaction Design",
      description: "Designing intuitive user flows and micro-interactions for seamless digital experiences.",
      image: interactionImg,
      path: "/services/uiux/interaction"
    },
    {
      title: "UI Design",
      description: "We craft beautiful and user-friendly interfaces that captivate audiences and deliver seamless digital experiences.",
      image: UiImg,
      path: "/services/uiux/ui"
    }
  ];

  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> UI/UX Design Services – BuddyTech Solutions </title>
        <meta name="description" content="User‑centric design from wireframes to interactive prototypes, ensuring delightful experiences." />
        <meta name="keywords" content="UI design, UX design, wireframing, prototyping" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="UI/UX Design Services – BuddyTech Solutions" />
        <meta property="og:description" content="User‑centric design from wireframes to interactive prototypes, ensuring delightful experiences." />
        <meta property="og:keywords" content="UI design, UX design, wireframing, prototyping" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="UI/UX Design Services – BuddyTech Solutions" />
        <meta name="twitter:description" content="User‑centric design from wireframes to interactive prototypes, ensuring delightful experiences." />
        <meta name="twitter:keywords" content="UI design, UX design, wireframing, prototyping" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="uiux-container">
        <header className="uiux-hero">
          <h1>UI/UX Design Services</h1>
          <p>We deliver user-first experiences through structured design strategies and engaging interfaces.</p>
        </header>
        <section className="uiux-services">
          {uiuxServices.map((service, index) => (
            <div className="uiux-card" key={index} onClick={() => navigate(service.path)}>
              <img src={service.image} alt={service.title} className="uiux-card-img" />
              <div className="uiux-card-body">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <button className="uiux-btn">Explore</button>
              </div>
            </div>
          ))}
        </section>
      </div>
    </>
  )
}

export default UIUX
